import { AddressableViewLayout } from 'framework/ViewTypes';
import { bindCollection } from 'framework/ViewTypes/contentLayout';
import { getBuisnessFunctionTableConfig } from './businessFunctionTableConfig';
import useBuisnessFunctionCollection from './useBuisnessFunctionCollection';

const BuisnessFunctionListPage = () => {
  const collection = useBuisnessFunctionCollection();

  const binding = bindCollection(
    collection,
    getBuisnessFunctionTableConfig(collection.rows, {
      onCreate: () => undefined,
      onEdit: () => undefined,
    }),
    { searchProps: {} },
  );

  return <AddressableViewLayout {...binding.pageProps} />;
};

export default BuisnessFunctionListPage;
